import RequestHandler from '../../customize/requestHandler';

export const contactUs = async data => {
	return RequestHandler.call({ url: '/api/v1/contact-us-messages', method: 'post', data }).then(res => res.data.result);
};
